import { createSlice } from '@reduxjs/toolkit';
import { deserialize } from 'deserialize-json-api';
import axios from '../../../utils/axios';
import { dispatch } from '../../store';

const initialState = {
  isLoading: false,
  error: null,
  outlets: [],
};
const outletsSclice = createSlice({
  name: 'retailerOutlets',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getOutlets(state, action) {
      state.isLoading = false;
      state.outlets = action.payload;
    },
  },
});
export function getAllOutlets() {
  axios
    .get('/retailer_app/api/v1/retailer/all_outlets')
    .then((response) => {
      const { data } = response.data;
      dispatch(outletsSclice.actions.getOutlets(data));
      dispatch(outletsSclice.actions.stopLoading());
    })
    .catch((error) => dispatch(outletsSclice.hasError(error)));
}
export default outletsSclice.reducer;
